module.exports = __webpack_public_path__ + "static/media/pencil-edit-button.77e63c93.svg";